import { z } from 'zod';
import { material } from '../materials/getMaterialsWithConditions';

const groupItemMaterial = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean().optional(),
  groupItemId: z.string(),
  mwAccountGroupId: z.string(),
  deleted: z.boolean().optional(),
  material: material,
});

export const getGroupItemMaterialsForGroupItemIdSchema = z.array(groupItemMaterial);

export type GetGroupItemMaterialsForGroupItemIdResponse = z.infer<
  typeof getGroupItemMaterialsForGroupItemIdSchema
>;
